module.exports = __webpack_public_path__ + "img/banner2.2d416f6c.png";